<div class="dah-cspace">
  <div class="parsys_column">
    <div class="parsys_column two_cols-c0">
      <p>{{tenant.content.landing.introText}}</p>
      <a [href]="tenant.content.loginUrl" class="mod_button icon user var_label">
        <span class="label">{{tenant.content.landing.loginButtonLabel}}</span>
      </a>
      <div class="mod_styledtext">
        <p>{{tenant.content.landing.registrationHint}}
          <a [href]="tenant.content.landing.registrationUrl">{{tenant.content.landing.registrationLinkLabel}}</a>.</p>
      </div>
    </div>

  </div>
</div>
